export default __webpack_public_path__ + "static/media/manual-sequence.f1dd1250.svg";